// @vendors
import { Modal } from "antd";

// @components
import AlertMessage from "components/alert-message";

export default function ModalWarning({ info, setModalWarning }) {
    return (
        <Modal
            width='760px'
            visible={info && info.visible}
            destroyOnClose
            footer={null}
            title={null}
            centered
            closable={false}
            wrapClassName='modal-warning'
        >
            <AlertMessage info={info ? info : {}} setModalWarning={setModalWarning} />
        </Modal>
    )
}